<div class="login-info-popup">
    <cross-button class="login-info-popup-close" size="large" (click)="closePopup()"></cross-button>
    <ng-content></ng-content>
</div>
